import axios from "axios";
import mapboxgl from "mapbox-gl";
import RouteMetrics from "../common/RouteMetrics";
import moment from "moment/moment";
import { makeId } from "@emberly/zenith-client";


export default class RoutePlanner {

  constructor(core, t) {
    this._core = core;
    this._t = t;
    this._destination = null;
    this._origin = null;
    this._route = null;
    this.excludeMotorway = false;
    this.language = "nb-NO";
    this._vehicleDetails = {};
    this._metadata = null;
  }

  clear() {
    this._destination = null;
    this._origin = null;
    this._route = null;
  }

  cancel() {
    this.clear();
  }

  reroute() {
    this.setDestination(this._destination, this._vehicleDetails);
  }

  async setDestination(destination, vehicleDetails = {}, metadata = null) {
    this._vehicleDetails = vehicleDetails;

    const pos = await this._core.getLocation();

    if (!!metadata) {
      this._metadata = metadata;
    }

    const bearing = typeof pos.coords?.heading === "number" ? pos.coords.heading : null
    const origin = { coordinates: [pos.coords.longitude, pos.coords.latitude] }

    const routeData = await this.fetchRoute(
      [
        origin,
        destination
      ],
      bearing,
      vehicleDetails?.height || 1.6,
      vehicleDetails?.width || 1.9,
      vehicleDetails?.weight || 2500,
    );

    this.clear();

    this._origin = origin;
    this._destination = destination;
    this._route = new RouteMetrics(routeData);
    this._core.setRoute(this._route);

    const routingData = {
      routeId: makeId(),
      origin: origin.coordinates,
      destination: destination.coordinates,
      created: moment().toDate(),
      heading: bearing,
      duration: this._route.duration,
      maxHeight: vehicleDetails?.height || 1.6,
      maxWidth: vehicleDetails?.width || 1.9,
      maxWeight: vehicleDetails?.weight || 2500,
      navigationType: this._metadata?.navigationType || 0,
      missionId: this._metadata?.missionId,
      taskId: this._metadata?.taskId,
    };


    this._core.reportRoute(routingData);
  }

  async fetchRoute(waypoints, bearing = null, maxHeight = 1.6, maxWidth = 1.9, maxWeight = 2500) {
    const queryCoordinates = waypoints.map(t => t.coordinates.join(",")).join(";");
    const bearingQuery = typeof bearing !== "number" ? "" : `&bearings=${bearing},45;`


    const query = `driving-traffic/${queryCoordinates}?access_token=${mapboxgl.accessToken}${bearingQuery}&alternatives=false${this.excludeMotorway ? "&exclude=motorway" : ""}&language=${this.language}&steps=true&annotations=speed,congestion_numeric&geometries=geojson&max_height=${maxHeight}&max_width=${maxWidth}&max_weight=${maxWeight / 1000.0}`;
    const res = await axios(`https://api.mapbox.com/directions/v5/mapbox/${query}&overview=full`);

    if (res.data?.routes?.length !== 0) {
      const data = res.data.routes[0];
      return data;
    }

    return null;
  }

  get origin() {
    return this._origin;
  }

}